/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import ContentLayout from 'components/Common/ContentLayout';
import TeamsAPI from 'api/TeamsAPI';
import GroupAPI from 'api/GroupAPI';
import PaymentsAPI from 'api/PaymentsAPI';
import { Redirect } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';
import { Button } from '@mui/material';
import UsersAPI from 'api/UsersAPI';

const ManualTeamSetup: React.FC = () => {
  const [formValues, setFormValues] = useState({
    teamName: '',
    teamAdmin: '',
  });
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();

  const biteScoreRoleId = process.env.REACT_APP_BITE_SCORE_ID!;
  const biteVizRoleId = process.env.REACT_APP_BITE_VIZ_ID!;

  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }

  const handleSubmit = async (formVals: any) => {
    const new_team: any = {
      name: formVals.teamName,
      team_admin_id: formVals.teamAdmin,
      team_id: '',
      keycloakUserId: cur_user?.basics?.id,
    };
    if (formVals.teamName === '') {
      enqueueSnackbar('Team name must not be blank');
      return;
    }
    const teamResp = await TeamsAPI.createTeam({ newTeam: new_team });
    const userResp = await UsersAPI.searchUsers(new_team.team_admin_id);
    if (teamResp?.success && userResp?.success) {
      const teamId = teamResp.result.id;
      new_team.team_id = teamId;
      const adminId = userResp?.result[0].id;
      const addUser = await GroupAPI.assignGroupToUser(teamId, adminId);
      if (addUser?.success) {
        const createStripeCustomer = await PaymentsAPI.createCustomer(new_team);
        if (createStripeCustomer?.success) {
          const addBiteScoreRole = await GroupAPI.addRoleToGroup(
            teamId,
            biteScoreRoleId,
            'bite-score',
          );
          if (addBiteScoreRole?.success) {
            const addBiteVizRole = await GroupAPI.addRoleToGroup(
              teamId,
              biteVizRoleId,
              'customizable',
            );
            if (addBiteVizRole?.success) {
              enqueueSnackbar('New team created', { variant: 'info' });
              history.go(0);
            }
          }
        }
      }
    } else if (teamResp || userResp) {
      const error_msg =
        'Error creating new team. Team name may already be in use';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const card: React.CSSProperties = {
    background: 'var(--Background-200, var(--bg-colors))',
    border: '1px solid var(--es-soft-border)',
    boxShadow: 'var(--es-card-shadow)',
    borderRadius: '12px',
    padding: '24px',
    width: '100%',
  };

  const row: React.CSSProperties = {
    display: 'flex',
    gap: '24px',
    width: '100%',
  };

  const combo: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1,
  };

  const label: React.CSSProperties = {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    color: 'var(--card-text)',
    margin: 0,
  };

  const input: React.CSSProperties = {
    height: '44px',
    borderRadius: '8px',
    border: '1px solid var(--es-soft-border)',
    background: 'var(--Background-200, var(--bg-colors))',
    boxShadow: 'var(--es-card-shadow)',
    color: 'var(--text-primary-color)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    padding: '0 12px',
    outline: 'none',
    width: '100%',
  };

  return (
    <ContentLayout title='Manual Setup for External BITE Teams' compact>
      <div style={card}>
        <div style={row}>
          <div style={combo}>
            <p style={label}>Team Name</p>
            <input
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  teamName: e.target.value,
                })
              }
              style={input}
              name='teamName'
              value={formValues.teamName}
            />
          </div>
          <div style={combo}>
            <p style={label}>Team Admin</p>
            <input
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  teamAdmin: e.target.value,
                })
              }
              style={input}
              name='teamAdmin'
              value={formValues.teamAdmin}
            />
          </div>
        </div>
        <div style={{ marginTop: '24px', textAlign: 'right' }}>
          <Button
            type='submit'
            className='wl-search-btn'
            onClick={() => handleSubmit(formValues)}
          >
            Submit
          </Button>
        </div>
      </div>
    </ContentLayout>
  );
};

export default ManualTeamSetup;
